import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, PropSync } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import pageMixins from "@mixins/pageMixins";
import commonMixins from "@mixins/commonNewMixins";
import { service } from "@modules/newCommunity/setup";
import SearchBox from "@/components/SearchBox/formWrap.vue";
import { formtemplateGenerateQuestionnaire } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import customPaginationTable from "@components/Table/customPaginationTable.vue";
function getListQuery() {
  return {
    title: "",
    id: ""
  };
}
let surveyTemplateSelectDialog = class surveyTemplateSelectDialog extends mixins(commonMixins, pageMixins) {
  constructor() {
    super(...arguments);
    this.listQuery = getListQuery();
    this.searchBoxSetting = {
      inline: true,
      block: true,
      labelWidth: "112px",
      style: {
        width: "220px"
      }
    };
    this.searchBox = [{
      key: "title",
      type: "input",
      label: "模板名称：",
      placeHolder: "请输入模板名称",
      size: "small",
      style: {
        width: "220px"
      }
    }, {
      key: "id",
      type: "input",
      label: "模板ID：",
      placeHolder: "请输入模板ID",
      size: "small",
      style: {
        width: "220px"
      }
    }];
    this.columns = [{
      type: "selection",
      width: "55px",
      fixed: true
    }, {
      label: "模版名称",
      prop: "title"
    }, {
      label: "模版ID",
      prop: "id"
    }];
    this.tableData = [];
    this.formatter = (row, column, cellValue) => {
      if (cellValue === 0 || cellValue === "0" || cellValue) {
        return cellValue;
      } else {
        return "-";
      }
    };
    this.loading = false;
    ////////////////////////
    this.multipleSelection = [];
  }
  onSearch() {
    this.pageParam.pageNum = 1;
    this.getTableData();
  }
  onReset() {
    this.pageParam.pageNum = 1;
    this.listQuery = getListQuery();
    this.getTableData();
  }
  onConditionChange() {
    this.getTableData();
  }
  getParmas() {
    let newParmas = JSON.parse(JSON.stringify(this.listQuery));
    return {
      ...newParmas,
      pageSize: this.pageParam.pageSize,
      pageNum: this.pageParam.pageNum,
      formProperty: this.questionnaireProperty
    };
  }
  getTableData() {
    this.loading = true;
    const params = this.getParmas();
    service.questionnaireTemplateGetPageInfo(params).then(res => {
      this.tableData = res.data.rows || [];
      this.pageParam.total = res.data.total;
    }).finally(() => {
      this.loading = false;
    });
  }
  created() {
    this.getTableData();
  }
  // handleSelectionChange(val: any) {
  //   this.multipleSelection = val;
  // }
  selectChange(selection) {
    if (selection.length > 1) {
      const del_row = selection.shift();
      this.$refs.templateTable.toggleRowSelection(del_row, false);
    }
    // console.log("selectChange", selection);
    this.multipleSelection = selection;
  }
  get questionnaireProperty() {
    return QuestionnaireEditModule.questionnaireProperty;
  }
  /////////////
  async handleConfirm() {
    if (this.multipleSelection.length > 0) {
      let checkRes = await service.questionnaireTemplateGetDetail({
        id: this.multipleSelection[0].id,
        copy: true
      });
      // console.log("checkRes", checkRes);
      if (checkRes.code == 200 && checkRes.data.deleteStatus == 1) {
        let qsRes = await formtemplateGenerateQuestionnaire({
          templateId: this.multipleSelection[0].id || ""
        });
        this.$emit("confirm", qsRes);
        this.visible = false;
      } else {
        this.$message({
          type: "error",
          message: "模板不存在， 请重新选择"
        });
      }
    } else {
      this.$message({
        type: "error",
        message: "请选择一个模板"
      });
    }
  }
  onOpen() {
    this.multipleSelection = [];
    this.onReset();
    // (this.$refs.templateTable as any).clearSelection();
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], surveyTemplateSelectDialog.prototype, "visible", void 0);
surveyTemplateSelectDialog = __decorate([Component({
  name: "surveyTemplateSelectDialog",
  components: {
    SearchBox,
    customPaginationTable
  }
})], surveyTemplateSelectDialog);
export default surveyTemplateSelectDialog;